import React from "react";
import { NavLink, Outlet } from "react-router-dom";

import { toggleShowAddDumpYardModal } from "../dumpYardsSlice";
import { useAppDispatch } from "../../../app/hooks";
import { DUMP_YARD_TABS } from "./dumpYardTabs";

import "./DumpYardsView.scss";

export function DumpYardsView() {
  const dispatch = useAppDispatch();

  const handleAddDumpYard = () => {
    dispatch(toggleShowAddDumpYardModal());
  };

  return (
    <div className="dump-yards-view-component">
      <div className="header">
        <h1>Dump Yards</h1>
        <button className="btn btn-primary" onClick={handleAddDumpYard}>
          + Add Dump Yard
        </button>
      </div>

      <div className="nav-tabs">
        {DUMP_YARD_TABS.map((tab) => (
          <NavLink
            key={tab.id}
            to={tab.id}
            className={({ isActive }) => `nav-tab ${isActive ? "active" : ""}`}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <div className="container">
        <Outlet />
      </div>
    </div>
  );
}
